/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const server = "production";
export const region = "EU";
export const urlBase = "https://dashboard-eu.smartwifi.ai";
export const radiusEndpointBase = "https://radius-eu.smartwifi.ai:8080/";
export const remoteManagerEndpointBase = "https://remotemanager-eu.smartwifi.ai:8080/";
export const smartWiFiExternalBase = "https://smartwifi.ai/";

export const s3Base = "https://smartwifi-eu-bucket.s3.eu-central-1.amazonaws.com/";

export const paypalClientId = "Ac93i23VEF40ifQddmLiKqTpI_DXJ_AZAnfaHU0ERAZN3DfkCyNtykHS70e9MXxAfYTomHO2nbX1v326";

export const smsService = "plivo";

export const billingPortalUrl = "https://billing.stripe.com/p/login/9AQ5mV1sseYc4Jq3cc";